var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", {
        attrs: {
          icon: "assignment",
          "no-padding": "",
          subtitle:
            "Use this query tool to compile data from multiple continuous data stations. The time series will update a short time after selection.",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-actions",
            { staticClass: "card-bg-2 py-0 layout wrap" },
            [
              _c("ContinuousDataDownload", {
                staticClass: "my-2 ml-0 mr-2",
                attrs: {
                  disabled: !_vm.canDownload,
                  selection: _vm.selection,
                  reportOptions: _vm.reportOptions,
                },
                on: {
                  loading: function ($event) {
                    _vm.isGeneratingReport = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { staticClass: "pt-0", staticStyle: { "min-width": "0" } },
                [
                  _c("QueryHeader", {
                    class: { "card-border-left": _vm.drawer },
                    attrs: { query: _vm.query },
                  }),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-tabs",
                    {
                      attrs: {
                        height: 32,
                        "slider-color": "info",
                        color: "transparent",
                      },
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    [
                      _c(
                        "v-tab",
                        {
                          staticClass: "selection-tab mx-1 mt-1",
                          attrs: { href: `#${_vm.availableTabs.parameters}` },
                        },
                        [_vm._v("\n            Report data\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        {
                          staticClass: "selection-tab mx-1 mt-1",
                          attrs: { href: `#${_vm.availableTabs.actions}` },
                        },
                        [_vm._v("\n            Report options\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        {
                          class: { "card-border-left": _vm.drawer },
                          attrs: { value: _vm.availableTabs.parameters },
                        },
                        [
                          _c("v-divider"),
                          _vm._v(" "),
                          _vm.loading
                            ? _c("v-progress-linear", {
                                staticClass: "position-sticky my-0",
                                attrs: {
                                  height: 10,
                                  color: "info",
                                  indeterminate: "",
                                },
                              })
                            : _c("div", {
                                staticClass: "card-bg-2",
                                staticStyle: { width: "100%", height: "10px" },
                              }),
                          _vm._v(" "),
                          _c("ViewContinuousDataQuery", {
                            ref: "viewQuery",
                            staticStyle: { "margin-top": "-10px" },
                            attrs: {
                              isGeneratingReport: _vm.isGeneratingReport,
                            },
                            on: {
                              "update:isInitialized": function ($event) {
                                _vm.isInitialized = $event
                              },
                              "update:loading": function ($event) {
                                _vm.loadingStates = $event
                              },
                              "update:selection": function ($event) {
                                return _vm.updateSelection($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { value: _vm.availableTabs.actions } },
                        [
                          _c("v-divider"),
                          _vm._v(" "),
                          _c("ContinuousReportParams", {
                            ref: "reportParams",
                            attrs: {
                              disabled: _vm.loading,
                              selection: _vm.selection,
                            },
                            on: {
                              "update:reportOptions": function ($event) {
                                _vm.reportOptions = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }